import { attributeTypes } from "./AttributeTypes";
import LayoutNode, { getNodeStyleAttributeValue } from "./LayoutNode";
import { ScreenSize } from "./ScreenSize";


export function GetFontRootColorClass(node:LayoutNode,):string{

    let dsktop = getNodeStyleAttributeValue(node,ScreenSize.Desktop,"color","");
    let tablet = getNodeStyleAttributeValue(node,ScreenSize.Tablet,"color","");
    let mobile = getNodeStyleAttributeValue(node,ScreenSize.Mobile,"color","");

    let cls = "";
    if(dsktop != "")
        cls+=" desktop-color ";
    if(tablet != "")
        cls+=" tablet-color ";
    if(mobile != "")
        cls+=" mobile-color ";



    return cls;

}

export function GetFontRootFontFamilyClass(node:LayoutNode,):string{

    let dsktop = getNodeStyleAttributeValue(node,ScreenSize.Desktop,attributeTypes.fontFamily,"");
    let tablet = getNodeStyleAttributeValue(node,ScreenSize.Tablet,attributeTypes.fontFamily,"");
    let mobile = getNodeStyleAttributeValue(node,ScreenSize.Mobile,attributeTypes.fontFamily,"");

    let cls = "";
    if(dsktop != "")
        cls+=" desktop-f ";
    if(tablet != "")
        cls+=" tablet-f ";
    if(mobile != "")
        cls+=" mobile-f ";



    return cls;

}